<template>
  <form autocomplete="off">
    <div class="w-full m-0">
      <div class="fullscreen-ckeditor example">
        <ckeditor :config="editorConfig" v-model="content" :value="content" @input="onEditorInput"></ckeditor>
      </div>
    </div>
    <div class="mt-4 text-right">
      <vs-button class="vs-component vs-button vs-button-primary vs-button-filled" color="warning"
        :disabled="button_loading" type="button" @click="saveData()">{{ $t('labels.save_data') }}</vs-button>
    </div>
  </form>
</template>

<script>
import Vue from "vue";
import CKEditor from "ckeditor4-vue";
Vue.use(CKEditor);
export default {
  components: {},
  props: ["executiveData", "projectId", "consultantId", "serviceId"],
  data() {
    return {
      editorConfig: {
        //height:'800px',
        toolbar: [
          { name: 'basicstyles', groups: ['basicstyles', 'cleanup'], items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'] },
          { name: 'paragraph', groups: ['list', 'indent', 'align', 'bidi'], items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr'] },
          { name: 'insert', items: ['Table', 'HorizontalRule', 'PageBreak',] },
          '/',
          { name: 'document', groups: ['mode', 'document', 'doctools'], items: ['Preview', 'Print', '-'] },
          { name: 'clipboard', groups: ['clipboard', 'undo'], items: ['Cut', 'Copy', 'Paste', 'PasteText', '-', 'Undo', 'Redo'] },
          { name: 'editing', groups: ['find', 'selection', 'spellchecker'], items: ['Find', 'Replace', '-', 'SelectAll', '-'] },
          '/',
          { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
          { name: 'colors', items: ['TextColor', 'BGColor'] },
          { name: 'tools', items: ['Maximize'] },
          { name: 'others', items: ['-'] },
          // { name: 'about', items: [ 'About' ] }
        ]

      },
      content: ''
    };
  },
  methods: {
    async saveData() {
      let input = {
        project_id: this.projectId,
        consultant_id: this.consultantId
      };
      if (this.serviceId === 1) {
        input = Object.assign(input, {
          service_id: 1,
          safety_inspection_executive_summary_template: this.content
        });
      }
      if (this.serviceId === 2) {
        input = Object.assign(input, {
          service_id: 2,
          navigation_assessment_executive_summary_template: this.content
        });
      }
      if (this.serviceId === 3) {
        input = Object.assign(input, {
          service_id: 3,
          internal_audit_executive_summary_template: this.content
        });
      }
      if (this.serviceId === 4) {
        input = Object.assign(input, {
          service_id: 4,
          visit_report_executive_summary_template: this.content
        });
      }
      if (this.serviceId === 5) {
        input = Object.assign(input, {
          service_id: 5,
          technical_inspection_executive_summary_template: this.content
        });
      }
      let response = await this.getHTTPPostResponse(
        "projects/store-executive-template",
        input,
        "",
        true
      );
      this.$emit('updated');
    },
    onEditorInput(val) {
      this.content = val
    }
  },
  computed: {},
  mounted() {
    console.log('in full screen')
    this.content = this.executiveData
  }
};
</script>

<style scoped>

</style>
